import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import BaseControl from './base-control';
import mapboxgl from '../utils/mapboxgl';
var propTypes = Object.assign({}, BaseControl.propTypes, {
  maxWidth: PropTypes.number,
  unit: PropTypes.oneOf(['imperial', 'metric', 'nautical'])
});
var defaultProps = Object.assign({}, BaseControl.defaultProps, {
  maxWidth: 100,
  unit: 'metric'
});

var ScaleControl = function (_BaseControl) {
  _inherits(ScaleControl, _BaseControl);

  function ScaleControl() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ScaleControl);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ScaleControl)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "_control", null);

    _defineProperty(_assertThisInitialized(_this), "_mapboxScaleControl", null);

    return _this;
  }

  _createClass(ScaleControl, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var mapboxScaleControl = new mapboxgl.ScaleControl();
      mapboxScaleControl._map = this._context.map;
      mapboxScaleControl._container = this._containerRef.current;
      this._mapboxScaleControl = mapboxScaleControl;

      this._update();
    }
  }, {
    key: "_update",
    value: function _update() {
      var mapboxScaleControl = this._mapboxScaleControl;

      if (mapboxScaleControl) {
        mapboxScaleControl.options = this.props;

        mapboxScaleControl._onMove();
      }
    }
  }, {
    key: "_render",
    value: function _render() {
      this._control = this._control || React.createElement("div", {
        ref: this._containerRef,
        className: "mapboxgl-ctrl mapboxgl-ctrl-scale"
      });

      this._update();

      return this._control;
    }
  }]);

  return ScaleControl;
}(BaseControl);

_defineProperty(ScaleControl, "propTypes", propTypes);

_defineProperty(ScaleControl, "defaultProps", defaultProps);

export { ScaleControl as default };